import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "proposal-view-container d-flex flex-column" }
const _hoisted_2 = { class: "proposal-main ma-4 d-flex" }
const _hoisted_3 = { class: "d-flex ml-4 flex-column w-100" }
const _hoisted_4 = { class: "d-flex mb-4" }

import PropHeader from "@/components/proposal/PropHeader.vue";
import PropSidebar from "@/components/proposal/PropSidebar.vue";
import { onMounted, ref } from "vue";
import { ApiMap } from "@/api/type";
import { useApi } from "@/api/handler";
import { game, team } from "@/api";
import { useRoute } from "vue-router";
import StepBar from "@/components/StepBar.vue";
import InitProp from "@/components/proposal/init/InitProp.vue";
import TeamOrder from "@/components/proposal/TeamOrder.vue";
import PropVoteOne from "@/components/proposal/vote/PropVoteOne.vue";
import KnockOut from "@/components/proposal/KnockOut.vue";
import PropVoteTwo from "@/components/proposal/vote/PropVoteTwo.vue";
import PropVoteThree from "@/components/proposal/vote/PropVoteThree.vue";
import BuzzQuiz from "@/components/proposal/BuzzQuiz.vue";
import SummaryBox from "@/components/SummaryBox.vue";
import RankList from "@/components/proposal/RankList.vue";
import TileRank from "@/components/board/TileRank.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'ProposalView',
  setup(__props) {

const GameStatus = ref<ApiMap['/game/status/:id']['resp'] | null>(null)
const gameId = ref<number>(0)
const route = useRoute()
const items = ref(['初始化积分', '轮次选择', '第一轮提案', '第二轮提案', '第三轮提案', '总结'])
const stage = ref<number>(0)
const showOverlay = ref<boolean>(false)
const currentMode = ref<'team' | 'student'>('team')

onMounted(() => {
  gameId.value = Number(route.query.id)
  useGameStatus()
})

function handleStage() {
  if (!GameStatus.value) return
  if (GameStatus.value.status === 2) stage.value = 5
  else if (GameStatus.value.proposalStage < 2) stage.value = GameStatus.value.proposalStage
  else stage.value = GameStatus.value.proposalRound + 1
}

const useGameStatus = () => {
  useApi({
    api: game.GameStatus(gameId.value),
    onSuccess: resp => {
      GameStatus.value = resp.data as ApiMap['/game/status/:id']['resp']
      handleStage()
    }
  })
}

return (_ctx: any,_cache: any) => {
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_overlay = _resolveComponent("v-overlay")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(PropHeader, {
        onShowOverlay: _cache[0] || (_cache[0] = ($event: any) => (showOverlay.value = true))
      }),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(PropSidebar, { data: GameStatus.value }, null, 8, ["data"]),
        _createElementVNode("div", _hoisted_3, [
          (GameStatus.value)
            ? (_openBlock(), _createBlock(_component_v_card, {
                key: 0,
                style: {"flex":"1"}
              }, {
                default: _withCtx(() => [
                  _createVNode(StepBar, {
                    class: "my-6 d-flex justify-center",
                    "model-value": stage.value,
                    items: items.value
                  }, null, 8, ["model-value", "items"]),
                  _createVNode(_component_v_divider),
                  (stage.value === 0)
                    ? (_openBlock(), _createBlock(InitProp, {
                        key: 0,
                        data: GameStatus.value,
                        onUpdate: useGameStatus
                      }, null, 8, ["data"]))
                    : _createCommentVNode("", true),
                  (stage.value === 1)
                    ? (_openBlock(), _createBlock(TeamOrder, {
                        key: 1,
                        data: GameStatus.value,
                        onUpdate: useGameStatus
                      }, null, 8, ["data"]))
                    : _createCommentVNode("", true),
                  (stage.value === 2 && GameStatus.value && GameStatus.value.proposalStage < 4)
                    ? (_openBlock(), _createBlock(PropVoteOne, {
                        key: 2,
                        data: GameStatus.value,
                        onUpdate: useGameStatus
                      }, null, 8, ["data"]))
                    : _createCommentVNode("", true),
                  (stage.value === 2 && GameStatus.value && GameStatus.value.proposalStage === 4)
                    ? (_openBlock(), _createBlock(KnockOut, {
                        key: 3,
                        data: GameStatus.value,
                        onUpdate: useGameStatus
                      }, null, 8, ["data"]))
                    : _createCommentVNode("", true),
                  (stage.value === 3)
                    ? (_openBlock(), _createBlock(PropVoteTwo, {
                        key: 4,
                        data: GameStatus.value,
                        onUpdate: useGameStatus
                      }, null, 8, ["data"]))
                    : _createCommentVNode("", true),
                  (stage.value === 4 && GameStatus.value && GameStatus.value.proposalStage < 4)
                    ? (_openBlock(), _createBlock(PropVoteThree, {
                        key: 5,
                        data: GameStatus.value,
                        onUpdate: useGameStatus
                      }, null, 8, ["data"]))
                    : _createCommentVNode("", true),
                  (stage.value === 4 && GameStatus.value && GameStatus.value.proposalStage === 4)
                    ? (_openBlock(), _createBlock(BuzzQuiz, {
                        key: 6,
                        data: GameStatus.value,
                        onUpdate: useGameStatus
                      }, null, 8, ["data"]))
                    : _createCommentVNode("", true),
                  (stage.value === 5)
                    ? (_openBlock(), _createBlock(SummaryBox, {
                        key: 7,
                        data: GameStatus.value
                      }, null, 8, ["data"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createVNode(_component_v_overlay, {
      modelValue: showOverlay.value,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((showOverlay).value = $event)),
      class: "align-center justify-center"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_v_btn, {
            color: currentMode.value === 'team' ? 'primary' : 'grey',
            onClick: _cache[1] || (_cache[1] = ($event: any) => (currentMode.value = 'team'))
          }, {
            default: _withCtx(() => _cache[4] || (_cache[4] = [
              _createTextVNode("团队排行榜")
            ])),
            _: 1,
            __: [4]
          }, 8, ["color"]),
          _createVNode(_component_v_btn, {
            color: currentMode.value === 'student' ? 'primary' : 'grey',
            onClick: _cache[2] || (_cache[2] = ($event: any) => (currentMode.value = 'student'))
          }, {
            default: _withCtx(() => _cache[5] || (_cache[5] = [
              _createTextVNode("个人排行榜")
            ])),
            _: 1,
            __: [5]
          }, 8, ["color"])
        ]),
        (currentMode.value === 'team')
          ? (_openBlock(), _createBlock(RankList, {
              key: "team",
              "enable-edit": true,
              "max-height": "630",
              class: "mr-6",
              style: {"width":"500px"},
              data: GameStatus.value
            }, null, 8, ["data"]))
          : (currentMode.value === 'student')
            ? (_openBlock(), _createBlock(TileRank, {
                key: "student",
                "enable-edit": true,
                "max-height": "630",
                class: "mr-6",
                style: {"width":"500px"},
                data: GameStatus.value,
                mode: "student"
              }, null, 8, ["data"]))
            : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})